import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {useAxiosPrivate} from "../useAxiosPrivate";

export default function useSubscriptionQueries() {
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient();

    // QUERIES ------------------------------------------------------

    const subscriptionListQuery = useQuery({
        queryKey: ["subscription"],
        queryFn: () =>
            axiosPrivate
                .get("subscription/")
                .then(r => r.data),
    });

    const useSubscriptionQuery = (id) =>
        useQuery({
            queryKey: ["subscription", id],
            queryFn: () =>
                axiosPrivate
                    .get(`subscription/${id}/`)
                    .then(r => r.data),
            enabled: !!id,
        });

    const subscriptionGetForBusinessQuery = useQuery({
        queryKey: ["subscription", "get_for_business"],
        queryFn: () =>
            axiosPrivate
                .get("subscription/get_for_business/")
                .then(r => r.data),
    });

    // MUTATIONS ------------------------------------------------------

    const useSubscriptionChangePlan = (onSuccess) =>
        useMutation({
            mutationFn: (data) =>
                axiosPrivate
                    .post("subscription/change_plan/", data)
                    .then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["subscription"]);
                onSuccess && onSuccess(...args);
            },
        });

    const useSubscriptionCancelSubscription = (onSuccess) =>
        useMutation({
            mutationFn: (data) =>
                axiosPrivate
                    .post("subscription/cancel_subscription/", data)
                    .then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["subscription"]);
                onSuccess && onSuccess(...args);
            },
        });

    // RETURN HOOKS ------------------------------------------------------

    return {
        subscriptionListQuery,
        useSubscriptionQuery,
        subscriptionGetForBusinessQuery,

        useSubscriptionChangePlan,
        useSubscriptionCancelSubscription,
    };
}
